// 미얀마 근로자용 In-App Message 템플릿 (확장된 버전)
export const myanmarMessageTemplates = {
  // 전문가 상담 서비스 관련
  consultation: {
    welcome: {
      id: 'consultation_welcome',
      title: '🩺 ကျွမ်းကျင်သူ ဆွေးနွေးမှု ဝန်ဆောင်မှု',
      body: 'သင့်တွင် မေးခွန်းများ ရှိပါသလား? ကျွမ်းကျင်သူများနှင့် ဆွေးနွေးပါ။',
      action: 'ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'high'
    },
    reminder: {
      id: 'consultation_reminder',
      title: '🩺 ဆွေးနွေးမှု ဝန်ဆောင်မှု အသုံးပြုပါ',
      body: 'အလုပ်နှင့် ပတ်သက်သော ပြဿနာများ၊ ကျန်းမာရေး မေးခွန်းများ ရှိပါသလား?',
      action: 'ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation',
      type: 'info',
      targetUsers: 'inactive_consultation_users',
      priority: 'medium'
    },
    success: {
      id: 'consultation_success',
      title: '✅ ဆွေးနွေးမှု ပြီးမြောက်ပါပြီ',
      body: 'သင့်မေးခွန်းကို ကျွမ်းကျင်သူများက ဖြေကြားပေးပါပြီ။',
      action: 'အဖြေကို ကြည့်ရှုပါ',
      actionUrl: '/consultation',
      type: 'success',
      targetUsers: 'consultation_users',
      priority: 'high'
    },
    health: {
      id: 'consultation_health',
      title: '🏥 ကျန်းမာရေး ဆွေးနွေးမှု',
      body: 'သင့်ကျန်းမာရေးနှင့် ပတ်သက်သော မေးခွန်းများ ရှိပါသလား?',
      action: 'ကျန်းမာရေး ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation?category=health',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    work: {
      id: 'consultation_work',
      title: '💼 အလုပ်နှင့် ပတ်သက်သော ဆွေးနွေးမှု',
      body: 'အလုပ်ခွင်တွင် ကြုံတွေ့ရသော ပြဿနာများကို ဆွေးနွေးပါ။',
      action: 'အလုပ်နှင့် ပတ်သက်သော ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation?category=work',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'high'
    },
    legal: {
      id: 'consultation_legal',
      title: '⚖️ ဥပဒေနှင့် ပတ်သက်သော ဆွေးနွေးမှု',
      body: 'ကိုရီးယားနိုင်ငံ၏ ဥပဒေများနှင့် ပတ်သက်သော မေးခွန်းများ ရှိပါသလား?',
      action: 'ဥပဒေနှင့် ပတ်သက်သော ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation?category=legal',
      type: 'warning',
      targetUsers: 'all_users',
      priority: 'high'
    },
    emergency: {
      id: 'consultation_emergency',
      title: '🚨 အရေးပေါ် ဆွေးနွေးမှု',
      body: 'အရေးပေါ်အခြေအနေတွင် ဆွေးနွေးမှု လိုအပ်ပါသလား?',
      action: 'အရေးပေါ် ဆွေးနွေးမှု စတင်ပါ',
      actionUrl: '/consultation?category=emergency',
      type: 'error',
      targetUsers: 'all_users',
      priority: 'high'
    }
  },

  // 소통의장 관련
  community: {
    welcome: {
      id: 'community_welcome',
      title: '👥 ဆက်သွယ်ရေး စင်တာ',
      body: 'သင့်ဒေသနှင့် လုပ်ငန်းနယ်ပယ်ရှိ မြန်မာအလုပ်သမားများနှင့် ဆက်သွယ်ပါ။',
      action: 'ဆက်သွယ်ရေး စင်တာ ဝင်ရောက်ပါ',
      actionUrl: '/community',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'high'
    },
    activity: {
      id: 'community_activity',
      title: '👥 ဆက်သွယ်ရေး စင်တာ လှုပ်ရှားမှု',
      body: 'သင့်ဒေသတွင် လှုပ်ရှားမှုများ ရှိနေပါသည်။ ပါဝင်ပါ။',
      action: 'ဆက်သွယ်ရေး စင်တာ ဝင်ရောက်ပါ',
      actionUrl: '/community',
      type: 'info',
      targetUsers: 'low_community_activity',
      priority: 'medium'
    },
    newPost: {
      id: 'community_new_post',
      title: '📝 ဆက်သွယ်ရေး စင်တာတွင် ပို့စ်အသစ်',
      body: 'သင့်ဒေသတွင် ပို့စ်အသစ်များ ရှိနေပါသည်။ ကြည့်ရှုပါ။',
      action: 'ပို့စ်များ ကြည့်ရှုပါ',
      actionUrl: '/community',
      type: 'info',
      targetUsers: 'community_users',
      priority: 'low'
    },
    jobSharing: {
      id: 'community_job_sharing',
      title: '💼 အလုပ်အခွင့်အလမ်း မျှဝေခြင်း',
      body: 'သင့်ဒေသတွင် အလုပ်အခွင့်အလမ်းများ မျှဝေနေပါသည်။',
      action: 'အလုပ်အခွင့်အလမ်းများ ကြည့်ရှုပါ',
      actionUrl: '/community?category=jobs',
      type: 'success',
      targetUsers: 'all_users',
      priority: 'high'
    },
    housing: {
      id: 'community_housing',
      title: '🏠 နေအိမ် ရှာဖွေခြင်း',
      body: 'သင့်ဒေသတွင် နေအိမ် ရှာဖွေနေသူများ ရှိနေပါသည်။',
      action: 'နေအိမ် ရှာဖွေမှု ကြည့်ရှုပါ',
      actionUrl: '/community?category=housing',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    event: {
      id: 'community_event',
      title: '🎉 ပွဲတော်နှင့် လှုပ်ရှားမှုများ',
      body: 'သင့်ဒေသတွင် ပွဲတော်နှင့် လှုပ်ရှားမှုများ ရှိနေပါသည်။',
      action: 'ပွဲတော်များ ကြည့်ရှုပါ',
      actionUrl: '/community?category=events',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    help: {
      id: 'community_help',
      title: '🤝 အကူအညီ ရှာဖွေခြင်း',
      body: 'သင့်ဒေသတွင် အကူအညီ ရှာဖွေနေသူများ ရှိနေပါသည်။',
      action: 'အကူအညီ ရှာဖွေမှု ကြည့်ရှုပါ',
      actionUrl: '/community?category=help',
      type: 'warning',
      targetUsers: 'all_users',
      priority: 'high'
    }
  },

  // 최신 뉴스 관련
  news: {
    breaking: {
      id: 'news_breaking',
      title: '📰 သတင်းအရေးကြီး',
      body: 'မြန်မာနိုင်ငံနှင့် ကိုရီးယားနိုင်ငံတွင် သတင်းအရေးကြီးများ ရှိနေပါသည်။',
      action: 'သတင်းများ ကြည့်ရှုပါ',
      actionUrl: '/community/myanmar-story',
      type: 'warning',
      targetUsers: 'all_users',
      priority: 'high'
    },
    daily: {
      id: 'news_daily',
      title: '📰 နေ့စဉ် သတင်းများ',
      body: 'မြန်မာနိုင်ငံနှင့် ကိုရီးယားနိုင်ငံ၏ နေ့စဉ် သတင်းများကို ကြည့်ရှုပါ။',
      action: 'သတင်းများ ကြည့်ရှုပါ',
      actionUrl: '/community/myanmar-story',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    }
  },

  // 송금 서비스 관련
  remittance: {
    welcome: {
      id: 'remittance_welcome',
      title: '💰 ငွေလွှဲပြောင်းမှု ဝန်ဆောင်မှု',
      body: 'မိသားစုများထံ ဘေးကင်းစွာ ငွေလွှဲပြောင်းပါ။',
      action: 'ငွေလွှဲပြောင်းပါ',
      actionUrl: '/remittance',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'high'
    },
    promotion: {
      id: 'remittance_promotion',
      title: '🎉 ငွေလွှဲပြောင်းမှု လျှော့စျေး',
      body: 'ဒီအပတ်တွင် ငွေလွှဲပြောင်းမှု လျှော့စျေး 50% ရရှိနိုင်ပါသည်။',
      action: 'ငွေလွှဲပြောင်းပါ',
      actionUrl: '/remittance',
      type: 'success',
      targetUsers: 'all_users',
      priority: 'high'
    },
    completed: {
      id: 'remittance_completed',
      title: '✅ ငွေလွှဲပြောင်းမှု ပြီးမြောက်ပါပြီ',
      body: 'သင့်ငွေလွှဲပြောင်းမှု အောင်မြင်စွာ ပြီးမြောက်ပါပြီ။',
      action: 'ငွေလွှဲပြောင်းမှု မှတ်တမ်း ကြည့်ရှုပါ',
      actionUrl: '/remittance/history',
      type: 'success',
      targetUsers: 'remittance_users',
      priority: 'high'
    },
    reminder: {
      id: 'remittance_reminder',
      title: '💰 ငွေလွှဲပြောင်းမှု သတိရပါ',
      body: 'မိသားစုများထံ ငွေလွှဲပြောင်းရန် သတိရပါ။',
      action: 'ငွေလွှဲပြောင်းပါ',
      actionUrl: '/remittance',
      type: 'info',
      targetUsers: 'inactive_remittance_users',
      priority: 'medium'
    }
  },

  // 미얀마 이야기 관련
  myanmarStory: {
    welcome: {
      id: 'myanmar_story_welcome',
      title: '📖 မြန်မာ ပုံပြင်များ',
      body: 'မြန်မာနိုင်ငံ၏ ယဉ်ကျေးမှု၊ ရိုးရာဓလေ့များနှင့် ပုံပြင်များကို ဖတ်ရှုပါ။',
      action: 'မြန်မာ ပုံပြင်များ ဖတ်ရှုပါ',
      actionUrl: '/community/myanmar-story',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    newStory: {
      id: 'myanmar_story_new',
      title: '📖 မြန်မာ ပုံပြင်အသစ်',
      body: 'မြန်မာနိုင်ငံ၏ ပုံပြင်အသစ်များ ရှိနေပါသည်။ ဖတ်ရှုပါ။',
      action: 'ပုံပြင်များ ဖတ်ရှုပါ',
      actionUrl: '/community/myanmar-story',
      type: 'info',
      targetUsers: 'myanmar_story_users',
      priority: 'low'
    }
  },

  // 쪽지 보내기 관련
  messaging: {
    welcome: {
      id: 'messaging_welcome',
      title: '💬 မက်ဆေ့ဂျ် ပို့ခြင်း',
      body: 'သင့်မိတ်ဆွေများနှင့် မက်ဆေ့ဂျ် ပို့ပါ။',
      action: 'မက်ဆေ့ဂျ် ပို့ပါ',
      actionUrl: '/community/messages',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    newMessage: {
      id: 'messaging_new_message',
      title: '💬 မက်ဆေ့ဂျ် အသစ်',
      body: 'သင့်ထံ မက်ဆေ့ဂျ် အသစ်များ ရောက်ရှိနေပါသည်။',
      action: 'မက်ဆေ့ဂျ်များ ကြည့်ရှုပါ',
      actionUrl: '/community/messages',
      type: 'info',
      targetUsers: 'messaging_users',
      priority: 'high'
    }
  },

  // 일반적인 독려 메시지
  encouragement: {
    daily: {
      id: 'encouragement_daily',
      title: '🌅 ကောင်းသော နေ့ဖြစ်ပါစေ',
      body: 'ဒီနေ့လည်း ကောင်းသော နေ့ဖြစ်ပါစေ။ ကျွန်ုပ်တို့၏ ဝန်ဆောင်မှုများကို အသုံးပြုပါ။',
      action: 'ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    },
    weekend: {
      id: 'encouragement_weekend',
      title: '🎉 အားလပ်ရက် ကောင်းပါစေ',
      body: 'အားလပ်ရက်တွင် ကောင်းစွာ အနားယူပါ။ မိသားစုများနှင့် ဆက်သွယ်ပါ။',
      action: 'ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    },
    holiday: {
      id: 'encouragement_holiday',
      title: '🎊 ပွဲတော်များ ကောင်းပါစေ',
      body: 'မြန်မာနိုင်ငံ၏ ပွဲတော်များတွင် ကောင်းစွာ ကျင်းပပါစေ။',
      action: 'ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    }
  },

  // 긴급 공지사항
  urgent: {
    system: {
      id: 'urgent_system',
      title: '⚠️ စနစ် ပြုပြင်မှု',
      body: 'စနစ် ပြုပြင်မှုကြောင့် ဝန်ဆောင်မှုများ ယာယီ ရပ်ဆိုင်းထားပါသည်။',
      action: 'ပိုမို သိရှိရန်',
      actionUrl: '/notices',
      type: 'warning',
      targetUsers: 'all_users',
      priority: 'high'
    },
    security: {
      id: 'urgent_security',
      title: '🔒 လုံခြုံရေး သတိပေးချက်',
      body: 'သင့်အကောင့် လုံခြုံရေးအတွက် သတိပေးချက်များ ရှိနေပါသည်။',
      action: 'လုံခြုံရေး စစ်ဆေးပါ',
      actionUrl: '/my-page',
      type: 'error',
      targetUsers: 'all_users',
      priority: 'high'
    }
  },

  // KYC 관련
  kyc: {
    reminder: {
      id: 'kyc_reminder',
      title: '📋 KYC အတည်ပြုချက် လိုအပ်ပါသည်',
      body: 'သင့်အကောင့် အတည်ပြုချက်အတွက် KYC လုပ်ငန်းစဉ် လိုအပ်ပါသည်။',
      action: 'KYC အတည်ပြုချက် စတင်ပါ',
      actionUrl: '/kyc',
      type: 'warning',
      targetUsers: 'incomplete_kyc_users',
      priority: 'high'
    },
    urgent_reminder: {
      id: 'kyc_urgent_reminder',
      title: '🚨 KYC အတည်ပြုချက် လိုအပ်ပါသည်',
      body: 'သင့်အကောင့် လုံခြုံရေးအတွက် KYC အတည်ပြုချက် လိုအပ်ပါသည်။ မြန်မာနိုင်ငံ လုပ်ငန်းဌာန၏ လိုအပ်ချက်ဖြစ်ပါသည်။',
      action: 'KYC အတည်ပြုချက် စတင်ပါ',
      actionUrl: '/kyc',
      type: 'error',
      targetUsers: 'no_kyc_users',
      priority: 'high'
    },
    approved: {
      id: 'kyc_approved',
      title: '✅ KYC အတည်ပြုချက် အောင်မြင်ပါပြီ',
      body: 'သင့် KYC အတည်ပြုချက် အောင်မြင်စွာ ပြီးမြောက်ပါပြီ။',
      action: 'အကောင့် စစ်ဆေးပါ',
      actionUrl: '/my-page',
      type: 'success',
      targetUsers: 'kyc_approved_users',
      priority: 'medium'
    },
    rejected: {
      id: 'kyc_rejected',
      title: '❌ KYC အတည်ပြုချက် ပြန်လည် စစ်ဆေးရန် လိုအပ်ပါသည်',
      body: 'သင့် KYC အတည်ပြုချက် ပြန်လည် စစ်ဆေးရန် လိုအပ်ပါသည်။',
      action: 'KYC ပြန်လည် စတင်ပါ',
      actionUrl: '/kyc',
      type: 'error',
      targetUsers: 'kyc_rejected_users',
      priority: 'high'
    }
  },

  // 대사관 서비스 관련
  embassy: {
    visa: {
      id: 'embassy_visa',
      title: '🛂 ဗီဇာ လျှောက်ထားခြင်း',
      body: 'ဗီဇာ လျှောက်ထားခြင်းနှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'ဗီဇာ ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/stay/embassy-reservations',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'high'
    },
    passport: {
      id: 'embassy_passport',
      title: '📘 နိုင်ငံကူးလက်မှတ် လျှောက်ထားခြင်း',
      body: 'နိုင်ငံကူးလက်မှတ် လျှောက်ထားခြင်းနှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'နိုင်ငံကူးလက်မှတ် ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/stay/embassy-reservations',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    document: {
      id: 'embassy_document',
      title: '📄 စာရွက်စာတမ်း အတည်ပြုချက်',
      body: 'စာရွက်စာတမ်း အတည်ပြုချက်နှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'စာရွက်စာတမ်း ဝန်ဆောင်မှုများ ကြည့်ရှုပါ',
      actionUrl: '/stay/documents',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    }
  },

  // 교육 서비스 관련
  education: {
    korean: {
      id: 'education_korean',
      title: '🇰🇷 ကိုရီးယား ဘာသာစကား သင်ယူခြင်း',
      body: 'ကိုရီးယား ဘာသာစကား သင်ယူခြင်းနှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'ကိုရီးယား ဘာသာစကား သင်ယူပါ',
      actionUrl: '/community/korean-study',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    skill: {
      id: 'education_skill',
      title: '🎓 ကျွမ်းကျင်မှု သင်ယူခြင်း',
      body: 'အလုပ်နှင့် ပတ်သက်သော ကျွမ်းကျင်မှုများ သင်ယူခြင်းနှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'ကျွမ်းကျင်မှု သင်ယူပါ',
      actionUrl: '/community/korean-study',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    certificate: {
      id: 'education_certificate',
      title: '🏆 လက်မှတ် ရယူခြင်း',
      body: 'အလုပ်နှင့် ပတ်သက်သော လက်မှတ်များ ရယူခြင်းနှင့် ပတ်သက်သော ဝန်ဆောင်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'လက်မှတ် ရယူပါ',
      actionUrl: '/community/korean-study',
      type: 'success',
      targetUsers: 'all_users',
      priority: 'medium'
    }
  },

  // 생활 정보 관련
  lifestyle: {
    weather: {
      id: 'lifestyle_weather',
      title: '🌤️ ရာသီဥတု သတင်းများ',
      body: 'ကိုရီးယားနိုင်ငံ၏ ရာသီဥတု သတင်းများကို ကြည့်ရှုပါ။',
      action: 'ရာသီဥတု သတင်းများ ကြည့်ရှုပါ',
      actionUrl: '/community',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    },
    transport: {
      id: 'lifestyle_transport',
      title: '🚌 သယ်ယူပို့ဆောင်ရေး သတင်းများ',
      body: 'ကိုရီးယားနိုင်ငံ၏ သယ်ယူပို့ဆောင်ရေး သတင်းများကို ကြည့်ရှုပါ။',
      action: 'သယ်ယူပို့ဆောင်ရေး သတင်းများ ကြည့်ရှုပါ',
      actionUrl: '/community',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    },
    shopping: {
      id: 'lifestyle_shopping',
      title: '🛒 ဈေးဝယ်ခြင်း သတင်းများ',
      body: 'ကိုရီးယားနိုင်ငံ၏ ဈေးဝယ်ခြင်း သတင်းများကို ကြည့်ရှုပါ။',
      action: 'ဈေးဝယ်ခြင်း သတင်းများ ကြည့်ရှုပါ',
      actionUrl: '',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    },
    food: {
      id: 'lifestyle_food',
      title: '🍜 မြန်မာ စားသောက်ဆိုင်များ',
      body: 'ကိုရီးယားနိုင်ငံတွင် မြန်မာ စားသောက်ဆိုင်များကို ကြည့်ရှုပါ။',
      action: 'မြန်မာ စားသောက်ဆိုင်များ ကြည့်ရှုပါ',
      actionUrl: '',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'low'
    }
  },

  // 이벤트 및 프로모션 관련
  promotion: {
    discount: {
      id: 'promotion_discount',
      title: '🎉 လျှော့စျေး ပရိုမိုးရှင်း',
      body: 'အထူး လျှော့စျေး ပရိုမိုးရှင်းများ ရရှိနိုင်ပါသည်။',
      action: 'လျှော့စျေး ပရိုမိုးရှင်းများ ကြည့်ရှုပါ',
      actionUrl: '',
      type: 'success',
      targetUsers: 'all_users',
      priority: 'high'
    },
    event: {
      id: 'promotion_event',
      title: '🎊 အထူး ပွဲတော်များ',
      body: 'မြန်မာ ပွဲတော်များနှင့် အထူး လှုပ်ရှားမှုများ ရှိနေပါသည်။',
      action: 'ပွဲတော်များ ကြည့်ရှုပါ',
      actionUrl: '',
      type: 'info',
      targetUsers: 'all_users',
      priority: 'medium'
    },
    reward: {
      id: 'promotion_reward',
      title: '🎁 ဆုလက်ဆောင် ရယူခြင်း',
      body: 'သင့်အတွက် ဆုလက်ဆောင်များ ရယူနိုင်ပါသည်။',
      action: 'ဆုလက်ဆောင်များ ရယူပါ',
      actionUrl: '',
      type: 'success',
      targetUsers: 'active_users',
      priority: 'medium'
    }
  },

  // Policy Compliance 관련
  policy_compliance: {
    reminder: {
      id: 'policy_compliance_reminder',
      title: '💝 မိသားစုများထံ ငွေလွှဲပြောင်းပါ',
      body: 'သင့်မိသားစုများကို စိတ်အေးချမ်းမှု ပေးနိုင်ရန် ငွေလွှဲပြောင်းမှု ပြုလုပ်ပါ။ မူဝါဒ လိုက်နာမှုကိုလည်း ထိန်းသိမ်းနိုင်ပါသည်။',
      action: 'ငွေလွှဲပြောင်းပါ',
      actionUrl: '/remittance',
      type: 'info',
      targetUsers: 'policy_compliance_low',
      priority: 'high'
    },
    urgent: {
      id: 'policy_compliance_urgent',
      title: '🚨 မူဝါဒ လိုက်နာမှု အရေးပေါ် အသိပေးချက်',
      body: 'မူဝါဒ လိုက်နာမှုသည် အလွန်နိမ့်ပါးနေပါသည်။ မြန်မာနိုင်ငံ လုပ်ငန်းဌာနမှ မကျေနပ်မှုများ ရရှိနိုင်ပါသည်။',
      action: 'ချက်ချင်း ငွေလွှဲပြောင်းပါ',
      actionUrl: '/remittance',
      type: 'error',
      targetUsers: 'all_users', // 임시로 all_users로 변경 (테스트용)
      priority: 'high'
    },
    employment_required: {
      id: 'employment_data_required',
      title: '📋 အလုပ်အကိုင် အခြေအနေ ထည့်သွင်းရန် လိုအပ်ပါသည်',
      body: 'မူဝါဒ လိုက်နာမှု စီမံခန့်ခွဲမှုအတွက် အလုပ်အကိုင် အခြေအနေကို ထည့်သွင်းပေးပါ။',
      action: 'အလုပ်အကိုင် အခြေအနေ ထည့်သွင်းပါ',
      actionUrl: '',
      type: 'info',
      targetUsers: 'no_employment_data',
      priority: 'high'
    },
    compliance_achieved: {
      id: 'policy_compliance_achieved',
      title: '✅ မူဝါဒ လိုက်နာမှု အောင်မြင်ပါပြီ',
      body: 'ဂုဏ်ယူပါတယ်! မူဝါဒ လိုက်နာမှု 100% အောင်မြင်ပါပြီ။',
      action: 'ငွေလွှဲပြောင်းမှု မှတ်တမ်း စစ်ဆေးပါ',
      actionUrl: '/remittance/history',
      type: 'success',
      targetUsers: 'policy_compliance_achieved',
      priority: 'medium'
    }
  }
};

// 메시지 카테고리별 분류
export const messageCategories = {
  consultation: {
    name: 'Expert Consultation Services',
    icon: '🩺',
    templates: myanmarMessageTemplates.consultation
  },
  community: {
    name: 'Communication Center',
    icon: '👥',
    templates: myanmarMessageTemplates.community
  },
  news: {
    name: 'Latest News & Updates',
    icon: '📰',
    templates: myanmarMessageTemplates.news
  },
  remittance: {
    name: 'Remittance Services',
    icon: '💰',
    templates: myanmarMessageTemplates.remittance
  },
  myanmarStory: {
    name: 'Myanmar Stories & Culture',
    icon: '📖',
    templates: myanmarMessageTemplates.myanmarStory
  },
  messaging: {
    name: 'Direct Messaging',
    icon: '💬',
    templates: myanmarMessageTemplates.messaging
  },
  encouragement: {
    name: 'Motivational Messages',
    icon: '🌅',
    templates: myanmarMessageTemplates.encouragement
  },
  urgent: {
    name: 'Urgent Notices',
    icon: '⚠️',
    templates: myanmarMessageTemplates.urgent
  },
  kyc: {
    name: 'KYC Verification',
    icon: '📋',
    templates: myanmarMessageTemplates.kyc
  },
  embassy: {
    name: 'Embassy Services',
    icon: '🏛️',
    templates: myanmarMessageTemplates.embassy
  },
  education: {
    name: 'Educational Services',
    icon: '🎓',
    templates: myanmarMessageTemplates.education
  },
  lifestyle: {
    name: 'Lifestyle & Community',
    icon: '🏠',
    templates: myanmarMessageTemplates.lifestyle
  },
  promotion: {
    name: 'Promotions & Events',
    icon: '🎉',
    templates: myanmarMessageTemplates.promotion
  },
  policy_compliance: {
    name: 'Policy Compliance Management',
    icon: '🛡️',
    templates: myanmarMessageTemplates.policy_compliance
  }
};

// 타겟팅 옵션 (영어)
export const targetingOptions = {
  all_users: 'All Users',
  myanmar_workers: 'Myanmar Workers',
  seoul_users: 'Seoul Users',
  gyeonggi_users: 'Gyeonggi Users',
  incheon_users: 'Incheon Users',
  inactive_users: 'Inactive Users',
  new_users: 'New Users',
  consultation_users: 'Consultation Users',
  inactive_consultation_users: 'Non-Consultation Users',
  community_users: 'Community Users',
  low_community_activity: 'Low Community Activity Users',
  remittance_users: 'Remittance Users',
  inactive_remittance_users: 'Non-Remittance Users',
  myanmar_story_users: 'Myanmar Story Users',
  messaging_users: 'Messaging Users',
  incomplete_kyc_users: 'Incomplete KYC Users',
  kyc_approved_users: 'KYC Approved Users',
  kyc_rejected_users: 'KYC Rejected Users',
  active_users: 'Active Users',
  busan_users: 'Busan Users',
  daegu_users: 'Daegu Users',
  gwangju_users: 'Gwangju Users',
  daejeon_users: 'Daejeon Users',
  ulsan_users: 'Ulsan Users',
  policy_compliance_low: 'Policy Compliance Low Users',
  policy_compliance_critical: 'Policy Compliance Critical Users',
  policy_compliance_achieved: 'Policy Compliance Achieved Users',
  no_employment_data: 'No Employment Data Users',
  no_kyc_users: 'No KYC Users'
};

// 우선순위 옵션 (영어)
export const priorityOptions = {
  high: 'High',
  medium: 'Medium',
  low: 'Low'
};

// 메시지 타입 옵션 (영어)
export const messageTypeOptions = {
  info: 'Information',
  success: 'Success',
  warning: 'Warning',
  error: 'Error'
};
